
import PropertyCard from '@/components/PropertyCard';
import { Property } from '@/types/property';
import { useAmplitudeEvents } from '@/utils/amplitudeEvents';

interface SearchResultsGridProps {
  filteredProperties: Property[];
  hasErrors: boolean;
  refetchAll: () => void;
  checkin?: string | null;
  checkout?: string | null;
}

const SearchResultsGrid = ({ 
  filteredProperties, 
  hasErrors, 
  refetchAll, 
  checkin, 
  checkout 
}: SearchResultsGridProps) => {
  const { trackWhatsAppBookingRequest } = useAmplitudeEvents();
  
  const handleWhatsAppBookingRequest = () => {
    trackWhatsAppBookingRequest();
    const whatsappUrl = "https://api.whatsapp.com/send?phone=+523335781778&text=Hola!+Me+gustar%C3%ADa+encontrarr+un+alojamiento.";
    window.open(whatsappUrl, '_blank');
  };

  if (filteredProperties.length > 0) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {filteredProperties.map((property) => (
          <PropertyCard 
            key={property.id} 
            id={property.id}
            title={property.title}
            shortDescription={property.shortDescription}
            price={property.price}
            rating={property.rating}
            guests={property.guests}
            images={property.images}
            neighborhood={property.neighborhood}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="text-center py-20">
      <div className="max-w-md mx-auto">
        <div className="text-gray-300 mb-6">
          <svg className="mx-auto h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m11 0a2 2 0 01-2 2H5a2 2 0 01-2-2m0 0V9a2 2 0 012-2h2M7 7h10" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          No se encontraron propiedades disponibles
        </h3>
        <p className="text-lg text-gray-600 mb-4">
          {checkin && checkout 
            ? 'No hay propiedades disponibles para las fechas seleccionadas. Intenta con otras fechas.'
            : 'Intenta ajustar tus criterios de búsqueda para encontrar más opciones.'
          }
        </p>
        <p className="text-lg text-gray-600 mb-6">
          Contáctanos para ayudarte a encontrar un alojamiento
        </p>
        <div className="space-y-4">
          <button 
            onClick={handleWhatsAppBookingRequest}
            className="bg-brand-primary text-white px-6 py-3 rounded-lg hover:bg-brand-primary-hover transition-colors font-medium"
          >
            Contactar por WhatsApp
          </button>
          {hasErrors && (
            <button 
              onClick={refetchAll}
              className="bg-brand-primary text-white px-6 py-2 rounded-lg hover:bg-brand-primary-hover transition-colors block mx-auto"
            >
              Verificar disponibilidad nuevamente
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchResultsGrid;
